// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__vqcU0","fileBtn":"File_fileBtn__SBkA6","closeBtn":"File_closeBtn__18kWE","fileSelected":"File_fileSelected__d7Ut1","disabled":"File_disabled__3fdsK"};